module.exports = __webpack_public_path__ + "static/fonts/iconfont.fc0d715.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1551407126619
// module id = 6BvB
// module chunks = 212